import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CircularProgress } from "@material-ui/core";
import { usePlatfromListLazyQuery } from "../../../graphql/types";

interface IPlatformProps {
  client: any;
  isMulti?: boolean;
  onChange: (value: any[] | any) => void;
  label: string;
}

export function Platform({
  client,
  onChange,
  isMulti = false,
  label,
}: IPlatformProps) {
  const [getList, { loading }] = usePlatfromListLazyQuery({
    client,
    onCompleted: (data) => {
      setOptions(data?.RnPlatformList?.data || []);
    },
  });

  const [options, setOptions] = React.useState<any[]>([]);
  const [value, setValue] = React.useState<any>([]);
  const [input, setInput] = React.useState<string>("");

  return (
    <Autocomplete
      disableCloseOnSelect
      multiple
      size="small"
      value={value ?? []}
      loading={loading}
      onOpen={() => {
        getList({
          variables: {
            params: {
              count: 10,
              offset: 0,
              filter: [
                {
                  field: "name",
                  operator: "LIKE",
                  values: [input],
                },
              ],
            },
          },
        });
      }}
      onChange={(e, value) => {
        setValue(value);
        onChange(value);
      }}
      inputValue={input}
      onInputChange={(e, name) => {
        setInput(name);
        getList({
          variables: {
            params: {
              count: 10,
              offset: 0,
              filter: [
                {
                  field: "name",
                  operator: "LIKE",
                  values: [name],
                },
              ],
            },
          },
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      getOptionSelected={(option, value) => {
        return option.id === value.id;
      }}
      getOptionLabel={(option) => option?.name}
      filterSelectedOptions
      options={options || []}
    />
  );
}
